export default (props:{
    color?: React.CSSProperties["color"]
}) => <div
    className="loader"
    style={{
        borderColor: props.color || "grey",
        borderBottomColor: "transparent",
    }}
    />